import { makeAutoObservable, flow } from 'mobx'
import { startOfDay, endOfDay, subDays } from 'date-fns'
import moment from 'moment'

import { TODAY } from 'admin/utils/helper'
import * as srv from 'admin/services'
import handleError from 'admin/services/error-handler'

export default class TransferRequestStore {
  loading = false
  processing = false
  openDialog = false
  selected = null
  list = []
  total = 0
  query = {
    columnIndex: -1,
    sortBy: 'createdAt',
    sortDirection: 'asc',
  }
  currentPage = 0
  rowsPerPage = 10
  startDate = startOfDay(subDays(TODAY(), 1))
  endDate = endOfDay(TODAY())

  constructor(rootStore) {
    makeAutoObservable(this, {
      reload: flow,
      fetch: flow,
    })
    this.rootStore = rootStore
  }

  updatePage = (page) => {
    this.currentPage = page
  }

  updateRowsPerPage = (perPage) => {
    this.rowsPerPage = perPage
  }

  updateStartDate = (value) => {
    this.startDate = value
  }

  updateEndDate = (value) => {
    this.endDate = value
  }

  updateQuery = (key, value, resetPage = false) => {
    this.query[key] = value
    if (resetPage) this.currentPage = 0
  }

  resetQuery = () => {
    this.query = {
      columnIndex: -1,
      sortBy: 'updatedAt',
      sortDirection: 'desc',
    }
    this.currentPage = 0
  }

  get queryParams() {
    const sDate = moment(this.startDate).startOf('day').toISOString()
    const eDate = moment(this.endDate).endOf('day').toISOString()
    const params = {
      sortBy: this.query.sortBy,
      sortDirection: this.query.sortDirection,
      limit: this.rowsPerPage,
      offset: this.currentPage * this.rowsPerPage,
      startDate: sDate,
      endDate: eDate,
    }
    return params
  }

  *reload(reset = false) {
    yield this.fetch()
    if (reset) {
      this.selected = { ...this.DEFAULT }
    }
  }

  *fetch(params) {
    try {
      this.loading = true
      const response = yield srv.fetchTransferRequest({
        ...this.queryParams,
        ...params,
      })
      if (response.ok) {
        this.list = response.data.list
        this.total = response.data.total
        return response.data
      }
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }
}
